export const HOLIDAY_DESC_MAX_LENGTH = 100;

export const REGISTRATION_VALIDATION_CONSTANTS = {
    PRIMARY_EMAIL_MAX_LENGTH: 130,
    ORG_MIN_LENGTH: 2,
    ORG_MAX_LENGTH: 100,
    NAME_MAX_LENGTH: 30,
    GIVEN_NAME_MAX_LENGTH: 60,
    FIRST_NAME_MAX_LENGTH: 12,
    FIRST_NAME_MIN_LENGTH: 3,
};

export const ProjectFormValidations = {
    ProjectNameMinLength: 3,
    ProjectNameMaxLength: 50,
    ProjectDescMinLength: 3,
    ProjectDescMaxLength: 255,
};

// Task/Work Item Form Validations
export const WORK_ITEM_FORM_VALIDATION_CONSTANTS = {
    TASK_TITLE_MIN_LENGTH: 3,
    TASK_TITLE_MAX_LENGTH: 70,
    TASK_DESC_MIN_LENGTH: 3,
    TASK_DESC_MAX_LENGTH: 5000,
    TASK_ESTIMATE_NUMBER_REGEX: "^0*[1-9][0-9]*$", // Regex to check if the number is a positive integer or not
    TASK_KEY_DECISIONS_MAX_LENGTH: 1000,
    TASK_ACCEPTANCE_CRITERIA_MAX_LENGTH: 1000,
    TASK_PARKING_LOT_MAX_LENGTH: 1000,
    BLOCKED_TASK_REASON_MIN_LENGTH: 3,
    BLOCKED_TASK_REASON_MAX_LENGTH: 1000,
    BUG_STEPS_TAKEN_MIN_LENGTH: 3,
    BUG_STEPS_TAKEN_MAX_LENGTH: 1000,
    PERSONAL_TASK_DESC_MAX_LENGTH: 5000,
    WORK_ITEM_NOTE_MAX_LENGTH: 500,
    WORK_ITEM_RCA_REASON_MIN_LENGTH: 3,
    WORK_ITEM_RCA_REASON_MAX_LENGTH: 250,
};

export const RECURRING_WORK_ITEM_CONSTANTS = {
    RECURRING_WORK_ITEM_DESCRIPTION_MAX_LENGTH: 5000,
    RECURRING_WORK_ITEM_DESCRIPTION_MIN_LENGTH: 3,
    RECURRING_WORK_ITEM_TITLE_MAX_LENGTH: 70,
    RECURRING_WORK_ITEM_TITLE_MIN_LENGTH: 3,
};

export const REMINDER_VALIDATION_CONSTANTS = {
    REMINDER_TITLE_MIN_LENGTH: 3,
    REMINDER_TITLE_MAX_LENGTH: 70,
    REMINDER_DESC_MIN_LENGTH: 3,
    REMINDER_DESC_MAX_LENGTH: 1000,
};

export const TEAM_VALIDATION_CONSTANTS = {
    TEAM_NAME_MIN_LENGTH: 3,
    TEAM_NAME_MAX_LENGTH: 50,
    TEAM_DESC_MIN_LENGTH: 3,
    TEAM_DESC_MAX_LENGTH: 1000,
};

export const INVITE_MEMBER_VALIDATION_CONSTANT = {
    EMAIL_MAX_LENGTH: 70,
    NAME_MAX_LENGTH: 30,
    MAX_VALIDITY_DAYS: 28,
};

export const SPRINT_VALIDATION_CONSTANTS = {
    SPRINT_TITLE_MIN_LENGTH: 3,
    SPRINT_TITLE_MAX_LENGTH: 70,
    SPRINT_OBJECTIVE_MIN_LENGTH: 3,
    SPRINT_OBJECTIVE_MAX_LENGTH: 1000,
};

export const EPIC_VALIDATION_CONSTANTS = {
    EPIC_TITLE_MIN_LENGTH: 3,
    EPIC_TITLE_MAX_LENGTH: 70,
    EPIC_DESC_MIN_LENGTH: 3,
    EPIC_DESC_MAX_LENGTH: 5000,
};

export const LEAVE_VALIDATION_CONSTANTS = {
    LEAVE_REASON_MIN_LENGTH: 3,
    LEAVE_REASON_MAX_LENGTH: 1000,
    LEAVE_ADDRESS_MAX_LENGTH: 1000,
    DELETE_REASON_MAX_LENGTH: 70,
    CANCELLATION_REASON_MAX_LENGTH: 70,
    APPROVE_REASON_MAX_LENGTH: 1000,
    REJECT_REASON_MAX_LENGTH: 1000,
};

export const MEETING_VALIDATION_CONSTANTS = {
    MEETING_TITLE_MIN_LENGTH: 3,
    MEETING_TITLE_MAX_LENGTH: 252,
    MEETING_LINK_MIN_LENGTH: 3,
    MEETING_LINK_MAX_LENGTH: 250,
    MEETING_VENUE_MIN_LENGTH: 3,
    MEETING_VENUE_MAX_LENGTH: 100,
    MEETING_AGENDA_MIN_LENGTH: 3,
    MEETING_AGENDA_MAX_LENGTH: 252,
};

export const ALERT_VALIDATION_CONSTANTS = {
    ALERT_REASON_MIN_LENGTH: 3,
    ALERT_REASON_MAX_LENGTH: 255,
};
export const CUSTOM_ENVIRONMENT_CONSTANTS = {
    ENVIRONMENT_MIN_LENGTH: 3,
    ENVIRONMENT_MAX_LENGTH: 255,
};

export const WORKFLOW_CONSTANTS = {
    WORKFLOW_DESCRIPTION_MAX_LENGTH: 5000,
    WORKFLOW_DESCRIPTION_MIN_LENGTH: 3,
    WORKFLOW_TITLE_MAX_LENGTH: 60,
    WORKFLOW_TITLE_MIN_LENGTH: 3,
};

export const WORKFLOW_INSTANCE_CONSTANTS = {
    WORKFLOW_INSTANCE_TITLE_MAX_LENGTH: 40,
    WORKFLOW_INSTANCE_TITLE_MIN_LENGTH: 3,
};

export const OVERTIME_VALIDATION_CONSTANTS = {
    REASON_MIN_LENGTH: 3,
    REASON_MAX_LENGTH: 1000,
    REMARKS_MIN_LENGTH: 3,
    REMARKS_MAX_LENGTH: 500,
};